import { render } from "./NotificationsDrawer.vue?vue&type=template&id=096d9674&ts=true"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__